module.exports = __webpack_public_path__ + "img/80779470_175664447153970_4704394038762800289_n.daa28a3c.jpg";